<div *ngIf="horizontalMenu && (!user || !user['userId'])" class="navbar-header"
     style="left: calc(4% - 56px);">
    <!-- Navbar brand -->
    <ul class="nav navbar-nav flex-row">
        <li class="nav-item">
            <a class="navbar-brand" (click)="goToHome()">
                <span class="d-none d-md-block brand-logo">
                    <!--<img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" style="max-width: 100px"/>-->
                    <img [src]="profileImage" alt="brand-logo" *ngIf="profileImage"/>
                </span>
                <span class="d-block d-md-none brand-logo" style="margin-left: 50px">
                    <img [src]="profileImage" alt="brand-logo" *ngIf="profileImage"/>
                </span>
                <!--<h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2>-->
                <h3 class="d-none d-md-block brand-text mb-0">{{university?.name.toUpperCase()}}</h3>
            </a>
        </li>
    </ul>
    <!--/ Navbar brand -->
</div>

<div class="navbar-container d-flex content" style="height: 60px">
    <div class="bookmark-wrapper d-flex align-items-center">
        <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
        <!--<ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
            <li class="nav-item">
                <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
                    <span [data-feather]="'menu'" [class]="'ficon'"></span>
                </a>
            </li>
        </ul>-->
        <!--/ Menu Toggler -->

        <!-- Toggle skin -->
        <!--<li class="nav-item d-none d-lg-block">
            <a type="button" class="nav-link nav-link-style btn" (click)="toggleDarkSkin()">
                <span [ngClass]="currentSkin === 'dark' ? 'fas fa-sun' : 'far fa-moon'"
                      class="ficon font-medium-5"></span>
            </a>
        </li>-->
        <!--/ Toggle skin -->
        <ul class="nav navbar-nav flex-row" *ngIf="user && user['userId']">
            <li class="nav-item">
                <a class="navbar-brand d-flex" (click)="goToHome()">
                    <span class="d-none d-md-block brand-logo" style="width: 50px; margin-left: -15px">
                        <img [src]="profileImage" alt="brand-logo" *ngIf="profileImage" style="width: 100%"/>
                    </span>
                    <span class="d-block d-md-none brand-logo">
                        <img [src]="profileImage" alt="brand-logo" *ngIf="profileImage" style="width: 48px; margin-left: -15px"/>
                        <!--<img [src]="coreConfig.app.appLogoImage" alt="brand-logo" style="max-width: 70px"/>-->
                    </span>
                    <h3 class="d-none d-md-block brand-text mb-0 ml-10px mt-10px text-primary">{{university?.name.toUpperCase()}}</h3>
                    <!--<h2 class="brand-text mb-0 text-primary ml-10px mt-10px">{{ coreConfig.app.appName }}</h2>-->
                    <!--<h2 class="brand-text mb-0">UMS - CRM</h2>-->
                </a>
            </li>
        </ul>
    </div>

    <ul class="nav navbar-nav align-items-center ml-auto">
        <!-- ? Language selection | Uncomment if needed-->
        <!-- <li ngbDropdown class="nav-item dropdown dropdown-language">
          <a class="nav-link dropdown-toggle" id="dropdown-flag" ngbDropdownToggle>
            <i class="flag-icon flag-icon-{{ languageOptions[_translateService.currentLang].flag }}"></i
            ><span class="selected-language">{{ languageOptions[_translateService.currentLang].title }}</span></a
          >
          <div ngbDropdownMenu aria-labelledby="dropdown-flag">
            <a *ngFor="let lang of _translateService.getLangs()" ngbDropdownItem (click)="setLanguage(lang)">
              <i class="flag-icon flag-icon-{{ languageOptions[lang].flag }}"></i> {{ languageOptions[lang].title }}
            </a>
          </div>
        </li> -->
        <!--/ Language selection -->
        <li ngbDropdown class="nav-item dropdown-user" *ngIf="!user || !user['user_id'] && !user['userId']">
            <!--<span class="font-weight-bolder text-primary cursor-pointer mr-2"
                  (click)="navigateTo('about-us')">About Us</span>
            <span class="font-weight-bolder text-primary cursor-pointer mr-2"
                  (click)="navigateTo('courses')">Courses</span>-->
            <span class="font-weight-bolder text-primary cursor-pointer" (click)="navigateTo('auth/login')">Login</span>
        </li>
        <!-- User Dropdown -->
        <li ngbDropdown class="nav-item dropdown-user" *ngIf="user && user['userId']">
            <a class="nav-link dropdown-toggle dropdown-user-link" id="dropdown-user" ngbDropdownToggle
               aria-haspopup="true" aria-expanded="false">
                <div class="user-nav d-sm-flex d-none">
                    <span class="user-name font-weight-bolder text-capitalize">{{user?.name.toLowerCase()}}</span>
                    <span class="text-capitalize user-status"
                          *ngIf="user && user['user_type'] && user['user_type'] !== 'SUPER_ADMIN'">{{(user && user['user_type']) ? user['user_type'].toLowerCase() : ''}}</span>
                    <span class="text-capitalize user-status"
                          *ngIf="user && user['user_type'] && user['user_type'] === 'SUPER_ADMIN'">Superadmin</span>
                </div>
                <span class="avatar">
                    <img class="round" [src]="studentProfile" alt="avatar"
                         height="40" width="40"/>
                        <span class="avatar-status-online"></span>
                </span>
            </a>
            <div ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right">
                <!--<a ngbDropdownItem (click)="navigateTo('admission')">
                    <span [data-feather]="'user'" [class]="'mr-50'"></span>Profile
                </a>-->
                <!--<a ngbDropdownItem [routerLink]="['/']">
                    <span [data-feather]="'mail'" [class]="'mr-50'"></span>Inbox
                </a>
                <a ngbDropdownItem [routerLink]="['/']">
                    <span [data-feather]="'check-square'" [class]="'mr-50'"></span>Task
                </a>
                <a ngbDropdownItem [routerLink]="['/']">
                    <span [data-feather]="'message-square'" [class]="'mr-50'"></span>Chats
                </a>-->
                <!--<div class="dropdown-divider"></div>-->
                <a ngbDropdownItem (click)="logOut()">
                    <span [data-feather]="'power'" [class]="'mr-50'"></span> Logout
                </a>
            </div>
        </li>
        <!--/ User Dropdown -->
    </ul>
</div>
